<template>
    <v-app>
        <!-- Navigation -->
        <navigation />

        <!-- Content -->
        <v-main>
            <!-- Content: Router view -->
            <router-view />

            <!-- Content: Loading -->
            <v-container v-if="loading">
                <v-skeleton-loader type="article" />
            </v-container>
        </v-main>

        <!-- Footer -->
        <Footer />
    </v-app>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";

@Component({
    components: { Footer, Navigation }
})
export default class App extends Vue {
    /**
     * If a route is currently loading.
     * @type {boolean}
     */
    loading = false;

    /**
     * When the component is created.
     */
    created() {
        this.$router.beforeEach((to, from, next) => {
            this.loading = true;
            next();
        });

        this.$router.afterEach(() => {
            this.loading = false;
        });
    }
}
</script>

<style lang="scss">
body {
    overflow-x: hidden !important;
}

p span {
    display: block;
}

.section {
    &--center {
        text-align: center;
    }

    &__title {
        color: var(--v-primary-base);
        font-size: 2em;
        padding-bottom: 7px;
    }
}

.container {
    margin-top: 20px;

    &--small {
        max-width: 1250px;
    }
}

.v-navigation-drawer {
    z-index: 1000;
}
</style>
